import curryN from "lodash/fp/curryN"
import { toNumber } from "utils"
export const PAGE_SIZE = 25
export const REDUCED_PAGE_SIZE = 10

export function limitAndOffset(
  params?: URLSearchParams,
  pageSize?: number,
): URLSearchParams {
  const _params = params || new URLSearchParams()
  const page = toNumber(_params.get("page"), 0)
  const _pageSize = toNumber(_params.get("pageSize"), pageSize ?? PAGE_SIZE)
  const offset = page * _pageSize
  _params.set("limit", _pageSize.toString())
  _params.set("offset", offset.toString())
  _params.delete("page")
  _params.delete("pageSize")
  return _params
}

export const defaultSort = curryN(
  2,
  function defaultSort(
    defaultValue: string,
    params: URLSearchParams | undefined,
  ): URLSearchParams {
    const _params = params || new URLSearchParams()
    if (!_params.has("sort")) {
      _params.set("sort", defaultValue)
    }
    return _params
  },
)
